import React from 'react';
import WhitelistPage from './pages/WhitelistPage';

function App() {
  return (
    <div className="App">
      <WhitelistPage />
    </div>
  );
}

export default App;
